import { render, staticRenderFns } from "./horizontal-topbar.vue?vue&type=template&id=b56acb24&scoped=true"
import script from "./horizontal-topbar.vue?vue&type=script&lang=js"
export * from "./horizontal-topbar.vue?vue&type=script&lang=js"
import style0 from "./horizontal-topbar.vue?vue&type=style&index=0&id=b56acb24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b56acb24",
  null
  
)

export default component.exports